const data = {
	"width": 512,
	"height": 512,
	"body": "<path fill=\"currentColor\" d=\"m359.873 121.377l-22.627 22.627l95.997 95.997H16v32.001h417.24l-95.994 95.994l22.627 22.627L494.498 256L359.873 121.377z\"/>"
};
exports.__esModule = true;
exports.default = data;
